import { HELP_DOCS_URL_GITCODE, HELP_DOCS_URL_ATOMGIT } from '@/constant';
export const whiteListForEnterprise = [17, 18]; // mindspore 17 欧拉 18
export const transformUrl = (url: string) => {
  if (!url) return url;
  // cdn-static.xxx / cdn-news.xxx 不需要转
  if (/cdn-static\.|cdn-img\.|cdn-news\./g.test(url)) {
    return url;
  }
  const host = location.host;
  const _host = host?.replace(/^test\.|pre\.|local\.|test-ai\.|ai\.|pre-ai\./, '');
  return url?.replace(/gitcode\.com|gitcode\.net/g, _host);
};

// 测服上没有web-api服务，使用当前域名的host
const apiTransformUrl = (url: string) => {
  const host = location.host;
  console.log('当前环境', (import.meta as any).env.VITE_ENV);
  // 如果是本地环境启动
  if (host.includes('local')) {
    return (import.meta as any).env.VITE_API_HOST;
  }
  const productionEnv = ['production', 'pre'];
  if (!productionEnv.includes((import.meta as any).env.VITE_ENV)) {
    return `https://${host}`;
  }
  const _host = host?.replace(/^pre\./, '');
  return url?.replace(/gitcode\.com/g, _host);
};

// 仓库文件下载域名
const repoFileDownloadUrl = (url: string) => {
  const host = location.host;
  // 本地环境
  if (host.includes('local')) {
    return (import.meta as any).env.VITE_DOWNLOAD_HOST;
  }
  // 测试环境没有raw，使用当前域名
  if ((import.meta as any).env.VITE_ENV === 'development') {
    return `https://${host}`;
  }
  // 预发环境 https://pre-raw.gitcode.com https://pre-raw.atomgit.com
  if ((import.meta as any).env.VITE_ENV === 'pre') {
    if (host.includes('atomgit.com')) {
      return 'https://pre-raw.atomgit.com';
    } else {
      return 'https://pre-raw.gitcode.com';
    }
  }
  const _host = host?.replace(/^test\.|pre\.|local\.|test-ai\.|ai\.|pre-ai\./, '');
  return url?.replace(/gitcode\.com/g, _host);
};

// 本地环境启动时，对于微应用处理，在本地运行时需要对不用的环境变量做不同的处理。
const localRunningSetting = (url: string) => {
  const host = location.host;
  const locEnv = ['loc', 'loc-pre'];
  let returnUrl = url?.replace(/gitcode\.com/g, host);
  if ((import.meta as any).env.VITE_ENV === 'development') {
    returnUrl = returnUrl.replace('child-app', 'child');
  }
  // 本地启动且非本地代理
  if (host?.includes('local')) {
    if (!locEnv.includes((import.meta as any).env.VITE_ENV)) {
      // 非本地代理
      // 代理测试环境
      if ((import.meta as any).env.VITE_ENV === 'development') {
        return returnUrl.replace('local', 'test');
      } else {
        // 代理预发环境
        return returnUrl.replace('local', 'pre');
      }
    } else {
      // 本地代理启动
      if (url?.includes('homeweb-app')) {
        return (import.meta as any).env.VITE_CHILD_HOMEWEB_HOST;
      }
      if (url?.includes('user-center')) {
        console.log((import.meta as any).env.VITE_USER_CENTER_HOST);
        return (import.meta as any).env.VITE_USER_CENTER_HOST;
      }
    }
  }
  return returnUrl;
};

// 跳转中间页域名处理
const interPageUrl = () => {
  const host = location.host;
  let url = 'https://link.';
  // 测试环境
  const testEnv = ['development', 'test', 'loc'];
  if (testEnv.includes((import.meta as any).env.VITE_ENV)) {
    url = 'https://test-link.';
  }
  // 预发环境
  const preEnv = ['pre', 'loc-pre'];
  if (preEnv.includes((import.meta as any).env.VITE_ENV)) {
    url = 'https://pre-link.';
  }
  if (host.includes('gitcode')) {
    url = url + 'gitcode.';
  }
  if (host.includes('atomgit')) {
    url = url + 'atomgit.';
  }
  if (host.includes('.host')) {
    url = url + 'host';
  }
  if (host.includes('.net')) {
    url = url + 'net';
  } else {
    url = url + 'com';
  }
  return `${url}`;
};

// 安全地获取环境变量，避免构建时 import.meta.env 为 undefined
const envValues: Record<string, any> = import.meta.env ? { ...import.meta.env } : {};
// 传入各环境变量值
// console.log('envValues', envValues);

// md编辑器内以及上传附件接口处理
// 文件内私有仓库需要替换为当前域名 包括图片链接和a链接保证域名一致
// 例如： https://gitcode.com/user-attachments/files/4384186/68eb2b014fbb460e96f4585eb044cf8b.gif 如果是私有仓库，则atomgit.com无法访问。只换域名预发环境与正式环境一致。
// flag表示强制跳过cdn静态域名保护
export const mdEditorUrl = (url: string, flag: boolean = false) => {
  const host = location.host;
  const productionEnv = ['production', 'pre', 'loc-pre'];
  // cdn-static.xxx / cdn-news.xxx 不需要转
  if (/cdn-static\.|cdn-img\.|cdn-news\./g.test(url) && !flag) {
    return url;
  }
  const _host = host?.replace(/^test\.|pre\.|local\.|test-ai\.|ai\.|pre-ai\./, '');
  // 测试环境
  if (!productionEnv.includes((import.meta as any).env.VITE_ENV)) {
    if (host.includes('gitcode.net')) {
      return url?.replace(/atomgit\.com/g, 'gitcode.net');
    }
    if (host.includes('atomgit.com')) {
      return url?.replace(/gitcode\.net/g, 'atomgit.com');
    }
  } else {
    if ((import.meta as any).env.VITE_ENV === 'loc-pre') {
      return url?.replace(/gitcode\.com/g, 'local.gitcode.com');
    }
    // 非测试环境域名 因为预发使用正式环境的 不能直接使用 return url?.replace(/gitcode\.com/g, host);
    if (host.includes('gitcode.com')) {
      return url?.replace(/atomgit\.com/g, _host);
    }
    if (host.includes('atomgit.com')) {
      return url?.replace(/gitcode\.com/g, _host);
    }
  }
  return url;
};
// 强制转换为gitcode域名，因为流水线需要的仓库地址是被存储了的，不能替换为新域名
export const transformGitcodeUrl = (url: string) => {
  const host = location.host;
  // 测试环境
  const testEnv = ['development', 'test'];
  if (host.includes('atomgit.com')) {
    if (testEnv.includes((import.meta as any).env.VITE_ENV)) {
      return url?.replace(/atomgit\.com/g, 'gitcode.net');
    } else {
      return url?.replace(/atomgit\.com/g, 'gitcode.com');
    }
  }
  return url;
};

// 根据当前 host 转换 URL 中的域名
// gitcode → atomgit
export const transformUrlHost = (url: string): string => {
  if (!url) return url;

  try {
    const urlObj = new URL(url);
    const isGitCode = isGitCodeHost();

    if (isGitCode) {
      // 当前是 gitcode，把 atomgit 替换成 gitcode
      urlObj.host = urlObj.host.replace(/atomgit\.com/g, 'gitcode.com');
    } else {
      // 当前是 atomgit，把 gitcode 替换成 atomgit
      urlObj.host = urlObj.host.replace(/gitcode\.com/g, 'atomgit.com').replace(/gitcode\.net/g, 'atomgit.com');
    }

    return urlObj.toString();
  } catch (error) {
    // URL 解析失败，降级为全局替换
    console.error('transformUrlHost: URL 解析失败', error);
    const isGitCode = isGitCodeHost();

    if (isGitCode) {
      return url.replace(/atomgit\.com/g, 'gitcode.com');
    } else {
      return url.replace(/gitcode\.com/g, 'atomgit.com').replace(/gitcode\.net/g, 'atomgit.com');
    }
  }
};

/**
 * 判断是否是 GitCode 主机
 * @returns 是否是 GitCode 主机
 */
export const isGitCodeHost = () => {
  return location.hostname.includes('gitcode');
};

export const currentHelpDocsUrl = (): string => (isGitCodeHost() ? HELP_DOCS_URL_GITCODE : HELP_DOCS_URL_ATOMGIT);

/**
 *
 * @returns 当前站点名称 - 统一返回 GitCode
 */
export const currentSiteName = (): string => 'AtomGit | GitCode';

/**
 *
 * @returns 当前站点名称
 */
export const currentSiteNameSingle = (): string => (isGitCodeHost() ? 'GitCode' : 'AtomGit');

// 主域名
export const VITE_HOST = () => transformUrl(envValues['VITE_HOST'] || 'https://gitcode.com');

// 天启域名
export const VITE_TIANQI_HOST = () => transformUrl(envValues['VITE_TIANQI_HOST'] || 'https://tianqi.gitcode.com');

// 接口地址
export const VITE_API_HOST = () => apiTransformUrl(envValues['VITE_API_HOST'] || 'https://web-api.gitcode.com');
// export const VITE_API_HOST = () => 'https://web-api.gitcode.host';

// Chat接口地址(主站未使用无需再处理)
export const VITE_CHAT_API_HOST = () => transformUrl(envValues['VITE_CHAT_API_HOST'] || 'https://chat-api.gitcode.com');

// devPress接口地址(主站未使用无需再处理)
export const VITE_DEV_API_HOST = () => transformUrl(envValues['VITE_DEV_API_HOST'] || 'https://gitcode.com');

// devPress地址(主站未使用无需再处理)
export const VITE_DEV_HOST = () => transformUrl(envValues['VITE_DEV_HOST'] || 'https://gitcode.com');

// 仓库文件上传域名(上传同当前域名)
export const VITE_FILE_HOST = () => transformUrl(envValues['VITE_FILE_HOST'] || 'https://gitcode.com');

// 仓库文件下载域名
export const VITE_DOWNLOAD_HOST = () => repoFileDownloadUrl('https://raw.gitcode.com');

// csdn登陆绑定地址 暂时无
export const VITE_CSDN_URL = () =>
  transformUrl(envValues['VITE_CSDN_URL'] || 'https://web-api.gitcode.com/oauth/login/csdn');

// 组织社区跳转地址
export const VITE_ORG_COMMUNITY = () => transformUrl(envValues['VITE_ORG_COMMUNITY'] || 'https://gitcode.com');

// 静态资源域名(固定)
export const VITE_STATIC_HOST = () => 'https://cdn-static.gitcode.com';

export const VITE_STATIC_ATOM_HOST = () => 'https://cdn-static.atomgit.com';

// 主页搜索子应用
export const VITE_CHILD_HOMEWEB_HOST = () => localRunningSetting('https://gitcode.com/child-app/homeweb-app/');

// 用户中心子应用
export const VITE_USER_CENTER_HOST = () => localRunningSetting('https://gitcode.com/child-app/user-center/');

// 成长中心子应用
export const VITE_GROWTH_CENTER_HOST = () => localRunningSetting('https://gitcode.com/child-app/growth-center/');

// ai-copilot 子应用
export const VITE_COPILOT_HOST = () => localRunningSetting('https://gitcode.com/child-app/aichat-app/');

// gitcode chat 子应用
export const VITE_GICODE_CHAT_HOST = () => localRunningSetting('https://gitcode.com/child-app/gitcode-chat/');

// gitcode chat 天启应用
export const VITE_GICODE_CHAT_TIANQI_HOST = () => localRunningSetting('https://gitcode.com/child-app/gitcode-tianqi/');

// ai-hub域名
export const VITE_AI_HOST = () => transformUrl(envValues['VITE_AI_HOST'] || 'https://ai.gitcode.com');

// News资讯中心
export const VITE_NEWS_HOST = () => transformUrl(envValues['VITE_NEWS_HOST'] || 'https://news.gitcode.com');

// codeArts域名
export const VITE_CODEARTS_HOST = () => transformUrl(envValues['VITE_CODEARTS_HOST'] || 'https://idea.gitcode.com');

// cookie domain
export const VITE_COOKIE_DOMAIN = () => transformUrl(envValues['VITE_COOKIE_DOMAIN'] || 'gitcode.com');

// AD_LINK 广告位json
export const VITE_AD_LINK = () => envValues['VITE_AD_LINK'] || 'https://cdn-static.gitcode.com/adList/active.json';

// AD_LINK 广告位json 成长中心
export const VITE_AD_LINK_GROWTH = () => 'https://cdn-static.gitcode.com/adList/active-growth.json';

// 主站域名
export const VITE_MAIN_API_HOST = () => transformUrl(envValues['VITE_MAIN_API_HOST'] || 'https://gitcode.com');

// 跳转中间页域名
export const VITE_INTERPAGE_HOST = () => interPageUrl();

// 迁移公告内容
export const VITE_MIGRATION_NOTICE = () => 'https://cdn-static.gitcode.com/json/migration/migration-notice.json';

// 天启入口地址
export const VITE_HOST_TIANQI = () => transformUrl(envValues['VITE_HOST_TIANQI'] || 'https://tianqi.gitcode.com');

// 大赛域名
export const VITE_COMPETITION_HOST = () =>
  transformUrl(envValues['VITE_COMPETITION_HOST'] || 'https://competition.gitcode.com');
